<template>
 <div>
    <span style="margin-left: 15px">{{ $t("Topo.delDeviceMessage") }}</span>
  </div>
</template>

<script>
export default {
  name: "DelConfirm",
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

